const STORAGE_KEY = 'wergame_referral_code';

export function normalizeReferralCode(raw) {
  return String(raw || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
}

export function captureReferralFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref') || params.get('referral');
    const code = normalizeReferralCode(ref);
    if (code) {
      localStorage.setItem(STORAGE_KEY, code);
    }
  } catch {
    // ignore
  }
}

/**
 * Persist a validated referral code, or clear storage + strip ?ref= when capped/invalid.
 * Returns { stored: boolean, capped?: boolean }.
 */
export function applyValidatedReferralCode(code, { valid, capped } = {}) {
  const normalized = normalizeReferralCode(code);
  try {
    if (valid && normalized) {
      localStorage.setItem(STORAGE_KEY, normalized);
      return { stored: true };
    }
    if (normalized && getStoredReferralCode() === normalized) {
      clearStoredReferralCode();
    }
    stripReferralParamsFromUrl();
    return { stored: false, capped: Boolean(capped) };
  } catch {
    return { stored: false };
  }
}

export function stripReferralParamsFromUrl() {
  try {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('ref') && !url.searchParams.has('referral')) return;
    url.searchParams.delete('ref');
    url.searchParams.delete('referral');
    const clean = `${url.pathname}${url.search}${url.hash}` || '/';
    window.history.replaceState({}, '', clean);
  } catch {
    // ignore
  }
}

export function getStoredReferralCode() {
  try {
    return localStorage.getItem(STORAGE_KEY) || '';
  } catch {
    return '';
  }
}

export function clearStoredReferralCode() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
